import { useMemo } from 'react';
import { GridColumnMenuCheckboxFilter } from '@progress/kendo-react-grid';

export const ColumnFilterMenu = (props) => {
    const { projectFilterItems, column, data, onFilterChange } = props;
    const field = column.field;

    const filterData = useMemo(() => {
        let baseData = [];

        if (projectFilterItems) {
            baseData = projectFilterItems.map(project => ({
                [field]: project
            }));
        } else {
            baseData = [...(data || [])].filter(item => item != null);
        }

        return baseData.sort((a, b) => { // Order checkbox items alphabetically
            const valueA = String(a[field] ?? "");
            const valueB = String(b[field] ?? "");
            return valueA.localeCompare(valueB, undefined, { sensitivity: 'base' });
        });
    }, [projectFilterItems, data, field]);

    const handleFilterChange = (filterDescriptor, syntheticEvent) => {
        if (projectFilterItems) {
            const updateOperators = (filter) => {
                if (!filter) return filter;

                if (filter.filters) {
                    return {
                        ...filter,
                        filters: filter.filters.map(updateOperators)
                    };
                }

                if (filter.field === field) {
                    return {
                        ...filter,
                        operator: (itemValue, filterValue) => {
                            if (!itemValue) return false;
                            
                            const individualNamesInCell = itemValue.split(',').map(s => s.trim());
                            return individualNamesInCell.includes(filterValue);
                        }
                    };
                }

                return filter;
            };

            const customFilterDescriptor = updateOperators(filterDescriptor);
            onFilterChange(customFilterDescriptor, syntheticEvent);
        } else {
            onFilterChange(filterDescriptor, syntheticEvent);
        }
    };

    return (
        <div className="hide-filter-header">
            <GridColumnMenuCheckboxFilter 
                {...props} 
                data={filterData}
                onFilterChange={handleFilterChange}
            />
        </div>
    );
};